import { type Node, variablesOf } from "@/lib/tool-kit/calculus/ast";
import { compile } from "@/lib/tool-kit/calculus/evaluate";
import { simplifyAt } from "@/lib/tool-kit/calculus/simplify";

/**
 * A value at a point: an exact closed form when the algebra allows one (7/3, 2√2,
 * cos(1) + 2) beside its decimal value.
 */
export interface PointValue {
  /** Exact form with the variable replaced; null if other variables remain. */
  exact: Node | null;
  /** The expression with the variable replaced, whether or not other variables remain. */
  symbolic: Node;
  /** Decimal value; NaN or ±Infinity if the expression is undefined there. */
  value: number;
}

export function valueAt(
  ast: Node,
  name: string,
  point: Node,
  pointValue: number
): PointValue {
  const exact = simplifyAt(ast, name, point);
  const closed = variablesOf(exact).length === 0 ? exact : null;
  return {
    exact: closed,
    symbolic: exact,
    value: compile(ast, name)(pointValue),
  };
}
